import { useActivityStore } from '@shared/store';
import { activityApi } from '../../apis';

// 初始化用所在群聊信息失败
export const initUserGroupWxIds = async () => {
  try {
    const { ret, retdata = [] } = await activityApi.getInGroupIds();

    ret === 0 && useActivityStore().setUserGroupWxIds(retdata || []);
  } catch (error) {
    console.error('初始化用所在群聊信息失败', error);
  }
};
